import { createReducer } from "@reduxjs/toolkit";
import {
  deleteDelivererSuccess,
  getDelivererListSuccess,
  LoadingData,
  loadingList,
  saveDelivererListSuccess,
} from "./delivererActions";

export interface IDelivererState {
  delivererList: Array<any>;
  dataCount: number;
  isLoading: boolean;
}

const initialState: IDelivererState = {
  delivererList: [],
  dataCount: 0,
  isLoading: false,
};

export const delivererReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(LoadingData, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(getDelivererListSuccess, (state, action) => {
      state = {
        ...state,
        delivererList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })

    .addCase(saveDelivererListSuccess, (state, action) => {
      state = {
        ...state,
        delivererList: action.payload,
      };
      return state;
    })

    .addCase(loadingList, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })

    .addCase(deleteDelivererSuccess, (state, action) => {
      const filteredList = state.delivererList.filter(
        (item) => !action.payload.includes(item.id)
      );
      return {
        ...state,
        delivererList: filteredList,
      };
    });
});


